import script from "./MindmapLoader.vue?vue&type=script&setup=true&lang=js"
export * from "./MindmapLoader.vue?vue&type=script&setup=true&lang=js"

import "./MindmapLoader.vue?vue&type=style&index=0&id=6aac2cca&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6aac2cca"]])

export default __exports__